export function historyBack(path: string, exclude?: RegExp): void {
  const isReferrer = Boolean(document.referrer) && document.referrer.includes('yanolja.com');
  const isExclude = exclude?.test(document.referrer) ?? true;
  isReferrer && isExclude ? history.back() : location.replace(path);
}
